// Placeholders for form fields across the application

export const TRAINING_CATALOGUE_PLACEHOLDERS = {
  // Add Training Needs Form
  selectedCatalog: "Select a catalog",
  trainingName: "Enter training name",
  programDuration: "Select Program Duration",
  trainingProviderName: "Enter provider name",
  trainingCostPerHead: "Enter cost per learner",
  targetedSkills: "Enter targeted skills",
  trainingDescription: "Enter training details including chapters, course topics, and curriculum information. Example: Chapter 1: Introduction, Chapter 2: Fundamentals, etc.",
  nqfAligned: "Select NQF Aligned",
  nqfLevel: "Select NQF Level",
  trainingUrl: "Enter URL (e.g., https://example.com)",
  
  // Add Catalogue Form
  catalogueName: "Enter catalogue name",
};

// Generic placeholders that can be reused
export const COMMON_PLACEHOLDERS = {
  select: "Select",
  enter: "Enter",
  search: "Search...",
  type: "Type...",
};

